export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/57a43ba76340ea303ae7dc89733370a0.svg";